module.exports = __webpack_public_path__ + "img/goals.23d21a0d.svg";